import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["iconLeft", "iconLeftView", "iconRight", "iconRightView"],
  _excluded2 = ["invert", "onlyIcon", "size", "view", "width", "loading", "mode", "className", "disabled", "onClick", "tagName", "iconLeft", "iconLeftView", "iconRight", "iconRightView"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var cnInline = cnBem('button-inline', styles);
var cnDefault = cnBem('button-default', styles);
var getClassName = function getClassName(_ref) {
  var onlyIcon = _ref.onlyIcon,
    size = _ref.size,
    view = _ref.view,
    width = _ref.width,
    loading = _ref.loading,
    mode = _ref.mode,
    className = _ref.className,
    invert = _ref.invert;
  var cnButton = mode === 'default' ? cnDefault : cnInline;
  return cnButton(_objectSpread({
    view: view,
    onlyIcon: onlyIcon,
    loading: loading
  }, mode === 'default' ? {
    size: size,
    width: width
  } : {
    invert: invert
  }), [className]);
};
export var iconInlineColorMap = {
  primary: 'primary',
  secondary: 'secondary',
  destructive: 'error'
};
export var iconInlineInvertColorMap = {
  primary: 'primary-invert',
  secondary: 'secondary-invert',
  destructive: 'error'
};
export var iconDefaultColorMap = {
  primary: 'black',
  secondary: 'primary',
  'secondary-invert': 'primary',
  tertiary: 'primary-invert',
  destructive: 'white'
};
export var spinnerColorMap = {
  primary: 'dark-white',
  secondary: 'dark-yellow',
  'secondary-invert': 'dark-yellow',
  tertiary: 'yellow-white',
  destructive: 'dark-white'
};
export var getIconColor = function getIconColor(_ref2) {
  var _ref2$view = _ref2.view,
    view = _ref2$view === void 0 ? 'primary' : _ref2$view,
    mode = _ref2.mode,
    disabled = _ref2.disabled,
    invert = _ref2.invert;
  if (disabled) {
    return view === 'tertiary' || invert ? 'disabled-invert' : 'disabled';
  }
  if (mode === 'default') {
    return iconDefaultColorMap[view];
  }
  return (invert ? iconInlineInvertColorMap : iconInlineColorMap)[view];
};
var getIconProps = function getIconProps(_ref3, side) {
  var iconLeft = _ref3.iconLeft,
    iconLeftView = _ref3.iconLeftView,
    iconRight = _ref3.iconRight,
    iconRightView = _ref3.iconRightView,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  if (typeof side === 'undefined') {
    return _objectSpread({
      icon: iconLeft || iconRight,
      iconView: iconLeftView || iconRightView
    }, otherProps);
  }
  return _objectSpread({
    icon: side === 'left' ? iconLeft : iconRight,
    iconView: side === 'left' ? iconLeftView : iconRightView
  }, otherProps);
};
export var dataConverter = function dataConverter(props) {
  var invert = props.invert,
    onlyIcon = props.onlyIcon,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$view = props.view,
    view = _props$view === void 0 ? 'primary' : _props$view,
    width = props.width,
    loading = props.loading,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'default' : _props$mode,
    classNameProp = props.className,
    disabled = props.disabled,
    onClick = props.onClick,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'button' : _props$tagName,
    iconLeft = props.iconLeft,
    iconLeftView = props.iconLeftView,
    iconRight = props.iconRight,
    iconRightView = props.iconRightView,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var className = getClassName({
    invert: invert,
    onlyIcon: onlyIcon,
    size: size,
    view: view,
    width: width,
    loading: loading,
    mode: mode,
    className: classNameProp
  });
  var iconProps = {
    iconLeft: iconLeft,
    iconLeftView: iconLeftView,
    iconRight: iconRight,
    iconRightView: iconRightView,
    disabled: disabled,
    invert: invert,
    loading: loading,
    mode: mode,
    onlyIcon: onlyIcon,
    view: view
  };
  var handleClick = function handleClick(e) {
    if (!loading && !disabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }
  };
  return _objectSpread({
    invert: invert,
    onlyIcon: onlyIcon,
    loading: loading,
    mode: mode,
    view: view,
    className: className,
    disabled: disabled,
    tagName: tagName,
    onClick: handleClick,
    iconLeftProps: getIconProps(iconProps, 'left'),
    iconRightProps: getIconProps(iconProps, 'right'),
    onlyIconProps: getIconProps(iconProps)
  }, otherProps);
};